import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 41367FBC-DCE3-4202-AF33-3AD576C3FD7C
 * name archive-alert
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-alert.svg
 * tags
 * - Alert / Error 
 */
export const ArchiveAlertIcon = createSvgIcon(<><path d="M2 4H18V7H2V4M3 8H17V20H3V8M7.5 11C7.22 11 7 11.22 7 11.5V13H13V11.5C13 11.22 12.78 11 12.5 11H7.5M20 13V7H22V13H20M20 17V15H22V17H20Z" /></>, 'ArchiveAlertIcon');
export default ArchiveAlertIcon